import Home from '@/components/page/Home/Home';
import Account from '@/components/page/Account/Account';
import Site from '@/components/page/Site';
import AreaForm from '@/components/page/Synoptic/Areas/AreaForm.vue';
import EquipmentForm from '@/components/page/Synoptic/Equipments/EquipmentForm.vue';
import DataView from '@/components/page/DataView/Index.vue';

export default [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/site/:siteUid?',
        name: 'Site',
        component: Site
    },
    {
        path: '/area/:areaType/:siteUid/:parentAreaUid?',
        name: 'Area',
        component: AreaForm
    },
    {
        path: '/equipment/:siteUid/:parentAreaUid',
        name: 'Equipment',
        component: EquipmentForm
    },
    {
        path: '/account',
        name: 'Account',
        component: Account
    },
    {
        path: '/data-view/:entity/:uid/:start_date/:end_date',
        name: 'DataView',
        component: DataView
    },

];



// WEBPACK FOOTER //
// ./src/router/routes.js